import { TimePicker, TimePickerChangeEvent } from "@progress/kendo-react-dateinputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import * as React from "react";
import { ManageCutOffViewModel } from "./ManageCutOffViewModel";
import TextInput from "../../Layout/Inputs/TextInput";
import { SetForAllCutOff } from "./SetForAllCutOff";
import { mapChanges } from "./MapChanges";
import { getDateFromString } from "../../Project/EditProject/RightSide/FtlTab/StopData/GetDateFromString";
import { getStringFromDate } from "../../Project/EditProject/RightSide/FtlTab/StopData/GetStringFromDate";
import { BranchViewModel } from "./BranchViewModel";
import { getLocalizedDataForBranches } from "./getLocalizedDataForBranches";
import { ReadOnlyProps } from "../../Project/EditProject/ReadOnlyProps";

type Props = {
  data: ManageCutOffViewModel[];
  onDataChanged: (changedData: ManageCutOffViewModel[]) => void;
  branches: Array<BranchViewModel>;
};

export const ManageCutOffControl = ({
  data,
  onDataChanged,
  branches,
  isReadOnly,
}: Props & ReadOnlyProps) => {
  const steps = {
    hour: 1,
    minute: 30,
    second: 0,
  };

  const unselectedBranchId = -1;
  const [inputValues, setInputValues] = React.useState<ManageCutOffViewModel>({
    CutOffTime: undefined,
    ReturnCutOffTime: undefined,
    TransitTime: undefined,
    ReturnTransitTime: undefined,
    BranchID: unselectedBranchId,
  });

  const handleChanges = (event: any) => {
    const { name, value } = event.target;
    setInputValues({ ...inputValues, [name]: value });
  };

  const handleChangesDropDown = (event: any) => {
    const { name, value } = event.target;
    setInputValues({ ...inputValues, [name]: value.value });
  };

  const handleTimeChanges = (event: TimePickerChangeEvent) => {
    const { name, value } = event.target;
    if (!name) {
      return;
    }
    setInputValues({ ...inputValues, [name]: getStringFromDate(value) });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: "4rem",
      }}
    >
      <div style={{ alignSelf: "center" }}>
        <SetForAllCutOff
          onClick={() => onDataChanged(mapChanges(data, inputValues))}
          isReadOnly={isReadOnly}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "18px",
          width: "60%",
          minWidth: "850px",
        }}
      >
        <TimePicker
          format="HH:mm"
          placeholder="HH:mm"
          steps={steps}
          label="Inbound Cut-Off Time"
          value={getDateFromString(inputValues.CutOffTime)}
          onChange={handleTimeChanges}
          name="CutOffTime"
          disabled={isReadOnly}
        />
        <TimePicker
          format="HH:mm"
          placeholder="HH:mm"
          steps={steps}
          label="Return Cut-Off Time"
          value={getDateFromString(inputValues.ReturnCutOffTime)}
          onChange={handleTimeChanges}
          name="ReturnCutOffTime"
          disabled={isReadOnly}
        />
        <TextInput
          label="Inbound Transit Days"
          name="TransitTime"
          type="number"
          step={1}
          value={inputValues.TransitTime}
          onChange={handleChanges}
          disabled={isReadOnly}
        />
        <TextInput
          label="Return Transit Days"
          name="ReturnTransitTime"
          type="number"
          step={1}
          value={inputValues.ReturnTransitTime}
          onChange={handleChanges}
          disabled={isReadOnly}
        />
        <DropDownList
          data={[{ text: "", value: unselectedBranchId }, ...getLocalizedDataForBranches(branches)]}
          style={{ minWidth: "300px" }}
          textField="text"
          dataItemKey="value"
          defaultValue={{ text: "", value: unselectedBranchId }}
          onChange={handleChangesDropDown}
          name="BranchID"
          label="Carrier Branch"
          disabled={isReadOnly}
        />
      </div>
    </div>
  );
};
